import React, { useContext } from "react";
import { Navigate } from "react-router";
import { AuthContext } from "./authcontext";

interface RedirectAuthenticatedProps {
  children: React.ReactNode;
}

export default function RedirectAuthenticated({
  children,
}: RedirectAuthenticatedProps) {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
